<template>
  <v-text-field
    :id="id"
    :label="label"
    v-model="displayedValue"
    :prepend-inner-icon="prependInnerIcon"
    :append-icon="appendIcon"
    :dense="dense ? dense : false"
    :hint="hint"
    :persistent-hint="persistentHint"
    :readonly="readonly"
    :rules="rulesValue"
    :validate-on-blur="validateOnBlur"
    :hide-details="hideDetails ? hideDetails : false"
    :clearable="!readonly ? (clearable ? clearable : false ) : false"
    :error="error"
    :disabled="disabled"
    :outlined="outlined !== undefined ? outlined : true"
    :tabindex="readonly ? '-1' : tabIndex"
    @focus="fieldFocus"
    @blur="fieldBlur"
    @keydown="fieldKeyDown"
  ></v-text-field>
</template>

<script>
import { nextTick } from 'vue'
import { required } from '@/lib/formValidations'
export default {
  props: [
    'label',
    'value',
    'prependInnerIcon',
    'appendIcon',
    'hint',
    'persistentHint',
    'dense',
    'readonly',
    'required',
    'rules',
    'onlyInt',
    'validateOnBlur',
    'hideDetails',
    'clearable',
    'error',
    'disabled',
    'tabIndex',
    'outlined'
  ],
  data () {
    return {
      displayedValue: isNaN(parseFloat(parseFloat(parseFloat(this.value).toFixed(2)).toLocaleString()))
        ? ''
        : parseFloat(parseFloat(this.value).toFixed(2)).toLocaleString(),
      id: 'txt' + Math.random().toString(16).slice(2)
    }
  },
  computed: {
    rulesValue: {
      get () {
        return !!this.rules && this.rules.length > 0 ? [this.requiredCheck(), ...this.rules] : [this.requiredCheck()]
      }
    }
  },
  watch: {
    value () {
      let tempValue = parseFloat(parseFloat(this.value).toFixed(2)).toLocaleString()
      this.displayedValue = isNaN(parseFloat(tempValue)) ? '' : tempValue
    },
    readonly () {
      let element = document.getElementById(this.id)
      if (this.readonly) {
        element.addEventListener('focus', this.preventFocus)
      } else {
        element.removeEventListener('focus', this.preventFocus)
      }
    }
  },
  methods: {
    requiredCheck () {
      return !this.required || required(this.label)
    },
    fieldFocus () {
      if (!this.readonly) {
        let value = parseFloat(this.value)
        this.displayedValue = isNaN(value) ? '' : value
      }
    },
    async fieldBlur (focusEvent) {
      if (!this.readonly) {
        this.$emit('valueChange', isNaN(parseFloat(this.displayedValue)) ? null : parseFloat(this.displayedValue))
        await nextTick()
        let value = parseFloat(parseFloat(this.value).toFixed(2)).toLocaleString()
        this.displayedValue = isNaN(parseFloat(value)) ? '' : value
        this.$emit('blur', isNaN(parseFloat(focusEvent.target.value)) ? null : parseFloat(focusEvent.target.value))
      }
    },
    fieldKeyDown (event) {
      let allowedKeyCodes = [
        8, // Backspace
        9, // Tab
        16, // Shift
        17, // Control
        18, // Alt
        33, // Page Up
        34, // Page Down
        35, // End
        36, // Home
        37, // Arrow Left
        38, // Arrow Up
        39, // Arrow Right
        40, // Arrow Down
        45, // Insert
        46 // Delete
      ]
      let regExp
      if (this.onlyInt) {
        regExp = new RegExp('[0-9]')
      } else {
        regExp = new RegExp('[0-9.]')
      }
      if (!allowedKeyCodes.includes(event.keyCode) && !regExp.test(event.key)) {
        event.preventDefault()
      }
    },
    preventFocus (event) {
      if (event.relatedTarget) {
        event.relatedTarget.focus()
      } else {
        event.currentTarget.blur()
      }
    }
  },
  mounted () {
    let element = document.getElementById(this.id)
    if (this.readonly) {
      element.addEventListener('focus', this.preventFocus)
    } else {
      element.removeEventListener('focus', this.preventFocus)
    }
  }
}
</script>
